import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-ripple-loader',
  templateUrl: './ripple-loader.component.html',
  styleUrl: './ripple-loader.component.scss',
  imports: [CommonModule],
  schemas: [NO_ERRORS_SCHEMA],
})
export class RippleLoaderComponent {
  [key: string]: any;
  constructor() {
  }


}
